import StyledInput from 'components/styledInput/StyledInput';

const AdditionalInfoSection = ({
  other,
  setOther,
  errorsOther,
  otherInterim,
  setOtherInterim,
  errorsOtherInterim,
  setDataCreateMission,
}) => {
  const onOtherChange = (text) => {
    setOther(text);
    setDataCreateMission((prev) => ({
      ...prev,
      other: text,
    }));
  };

  const onOtherInterimChange = (text) => {
    setOtherInterim(text);
    setDataCreateMission((prev) => ({
      ...prev,
      other_interim: text,
    }));
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="text-xl">Informations supplémentaires</div>
      <StyledInput
        type="textarea"
        label="Informations pour le candidat sélectionné"
        value={other}
        onChange={(e) => onOtherChange(e.target.value)}
        error={errorsOther}
      />
      <StyledInput
        type="textarea"
        label="Informations pour l'agence"
        value={otherInterim}
        onChange={(e) => onOtherInterimChange(e.target.value)}
        error={errorsOtherInterim}
      />
    </div>
  );
};

export default AdditionalInfoSection;
